import React, {useRef} from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const RichTextEditor = ({value,setValue}) => {
    const quillRef = useRef(null);

    const modules = {
        toolbar: [
            [{ 'size': ['small', 'medium', 'large'] }],
            ['bold', 'italic', 'underline', 'strike', 'blockquote'],
            [{ 'align': [] }, { 'direction': 'rtl' }],
            [{'list': 'ordered'}, {'list': 'bullet'}],
            ['clean']
        ],
    }
    const handleKeyPress = (e) => {
        if (e.key === ' ' && e.shiftKey) {
          e.preventDefault();
          const quill = quillRef.current.getEditor();
          const range = quill.getSelection();
          quill.insertText(range.index, '\u200C'); // Insert ZWNJ
          quill.setSelection(range.index + 1);
        }
      };
    return (
        <ReactQuill
            value={value}
            ref={quillRef}
            onChange={(e)=>{setValue(e)}}
            onKeyDown={handleKeyPress}
            modules={modules}
            style={{direction: 'rtl',background:'#fff'}}
        />
    );
};

export default RichTextEditor;
